import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed, onMounted, ref } from 'vue'

import { getImage, QuestionnaireView } from '@/models/onboarding'
import { Loading16167Page } from '@/models/onboarding.types'
import { PublicInterface } from '@/models/interfaces'

import Rive from '@/app/components/Rive.vue'
import Layout from '../Layout.vue'
import { waitTimer } from '@/helpers/timer'
import { storage } from '@/helpers/storage'


export default /*@__PURE__*/_defineComponent({
  __name: 'Loading16167',
  props: {
    view: {}
  },
  setup(__props: any) {

const props = __props

const page = computed(() => {
  return props.view.currentPage as Loading16167Page
})

const currentState = ref<'loading' | 'done' | 'error'>('loading')

const currentAnimation = computed(() => {
  return currentState.value === 'loading' ? 'loading' : 'loaded'
})

const currentTitle = computed(() => {
  switch (currentState.value) {
    case 'loading':
      return page.value.title
    case 'done':
      return page.value.titleDone
    case 'error':
      return page.value.titleError
    default:
      return page.value.titleError
  }
})

onMounted(async () => {
  try {
    // Create the reading list from the choices from the previous page,
    // and wait at least 3 second.
    const [response] = await Promise.allSettled([
      props.view.createReadingList16167(),
      waitTimer(3000),
    ])
    if (response.status === 'rejected') {
      throw response.reason
    }

    currentState.value = 'done'
  } catch (error) {
    currentState.value = 'error'
    // Remove the book covers from local storage
    // to prevent the reading list widget from being
    // shown in the Discover
    storage.removeItem('sf_lq_books16167')
  }

  props.view.showContinueButton()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Layout, {
    class: "onboarding-loading16167",
    title: currentTitle.value,
    titleTransition: true
  }, {
    aboveTitle: _withCtx(() => [
      _createVNode(Rive, {
        class: "onboarding-loading16167__rive",
        src: _unref(getImage)(page.value.animation.src),
        width: page.value.animation.width,
        height: page.value.animation.height,
        animations: currentAnimation.value,
        fit: "FitWidth",
        alignment: "BottomCenter"
      }, null, 8, ["src", "width", "height", "animations"])
    ]),
    _: 1
  }, 8, ["title"]))
}
}

})